import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {ShippingClientListItemDto} from "../../api/fms";
import {pageLoadingStore} from "../PageLoadingStore";

const systemApi = api.fms.api

class FmsShippingClientListStore {
    get size(): number {
        return this._size;
    }

    set size(value: number) {
        this._size = value;
    }
    get page(): number {
        return this._page;
    }

    set page(value: number) {
        this._page = value;
    }
    get pages(): number {
        return this._pages;
    }

    set pages(value: number) {
        this._pages = value;
    }
    get items(): ShippingClientListItemDto[] {
        return this._items;
    }

    set items(value: ShippingClientListItemDto[]) {
        this._items = value;
    }

    private _items: ShippingClientListItemDto[] = []
    private _pages: number = 0
    private _page: number = 1
    private _size: number = 25
    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        pageLoadingStore.loading = true
        const {
            page,
            size,
        } = this
        const result = await catchApi(async () => await systemApi.listShippingClients({
            page: page - 1,
            size
        }))

        const data = result?.data
        if (data?.items) {
            this.items = data.items
            this.pages = data.totalPages || 0
        } else {
            this.items = []
            this.pages = 0
        }
        pageLoadingStore.loading = false
    }
}

const fmsShippingClientListStore = new FmsShippingClientListStore()

export {
    fmsShippingClientListStore
}
